export const environment = {
  env: 'prod',
  wildApiUrl: 'https://api.sacramentoda.org/wild/',
  authApiUrl: 'https://api.sacramentoda.org/',
  awsBucketApiUrl: '',
  s3file: "https://dacommongateway.sacda.org/DAFileProcessor/",
  appId: 16,
  appName: 'WILD',
  awsRegion: 'us-gov-west-1',
  narraviveAgencyId: 3240,
  unitId: 21,
  cidUnitId: 15,
  juviUnitId: 25

};
